<template>
  <Teleport to="body">
<div class="modal fade" tabindex="-1" :id="id">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Fechar">
            <i class="bi bi-x-lg"></i>
          </div>
        </div>
        <div class="modal-body">
          <div class="document-row" v-for="document in documents" :key="document.prescription.id_presc">
            <div class="document-info">
              <div class="document-header">
                <RegulatoryBadge :classification="badgeFor(document)"/>
                <span class="document-name">{{ typeName(document) }}</span>
              </div>
              <p class="document-meta">
                <span>#{{ document.prescription.id_presc }}</span>
                <span v-if="document.prescription.sncr_number">Numeração {{ document.prescription.sncr_number }}</span>
                <span :class="document.prescription.presc_request_signed ? 'document-signed' : 'document-unsigned'">
                  <i class="bi" :class="document.prescription.presc_request_signed ? 'bi-pen-fill' : 'bi-pen'"></i>
                  {{ document.prescription.presc_request_signed ? 'Assinado digitalmente' : 'Sem assinatura digital' }}
                </span>
              </p>
            </div>
            <button type="button" class="btn btn-sm btn-primary" @click="$emit('open', document)">
              <i class="bi bi-file-pdf"></i>
              Ver PDF
            </button>
          </div>
        </div>
        <div v-if="blocked.length" class="document-blocked">
          <p class="document-blocked-title">
            {{ blocked.length === 1 ? 'Um documento não foi emitido por falta de numeração:' : `${blocked.length} documentos não foram emitidos por falta de numeração:` }}
          </p>
          <ul class="document-blocked-list">
            <li v-for="item in blocked" :key="item.id_presc">
              <strong>{{ item.regulatory_type_description }}</strong> — {{ item.message }}
            </li>
          </ul>
          <button v-if="professionalId" type="button" class="btn btn-sm btn-primary"
                  :disabled="authenticating" @click="authenticate">
            {{ authenticating ? 'Abrindo gov.br...' : 'Autenticar no gov.br' }}
          </button>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
        </div>
      </div>
    </div>
  </div>
  </Teleport>
</template>

<script>
import RegulatoryBadge from "./RegulatoryBadge.vue";
import Alert from "@/helpers/alert";
import {classificationFromType, regulatoryTypeName} from "@/helpers/regulatoryTypes";
import {startGovBrAuth} from "@/helpers/sncr";

export default {
  name: "PrescriptionDocumentsModal",
  components: {RegulatoryBadge},
  emits: ['open'],
  props: {
    id: String,
    documents: {
      type: Array,
      default: () => [],
    },
    blocked: {
      type: Array,
      default: () => [],
    },
    professionalId: [Number, String],
    returnTo: Object,
  },
  data() {
    return {
      authenticating: false,
    }
  },
  computed: {
    title() {
      return this.documents.length === 1
          ? 'Documento gerado'
          : `${this.documents.length} documentos gerados`;
    },
  },
  methods: {
    badgeFor(document) {
      return classificationFromType(document.prescription.regulatory_type);
    },
    typeName(document) {
      return regulatoryTypeName(document.prescription.regulatory_type, document.prescription.presc_name ?? 'Prescrição');
    },
    authenticate() {
      this.authenticating = true;

      const destino = this.returnTo ?? {path: this.$route.fullPath, professionalId: this.professionalId};

      startGovBrAuth(this.professionalId, destino).catch(() => {
        this.authenticating = false;
        Alert.toastError('Não foi possível abrir a autenticação do gov.br. Tente novamente.');
      });
    },
  },
}
</script>

<style scoped>
.document-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  border: 1px solid #e9ecef;
  border-left: 3px solid #780f5a;
  border-radius: 8px;
  padding: 12px 16px;
  margin-bottom: 12px;
}

.document-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 6px;
}

.document-name {
  font-weight: 700;
  color: #212529;
}

.document-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin: 0;
  color: #6c757d;
  font-size: 0.85rem;
}

.document-blocked {
  border: 1px solid #f3c0c0;
  border-left: 3px solid #c92a2a;
  border-radius: 8px;
  background: #fff5f5;
  padding: 12px 16px;
  margin: 0 16px 8px 16px;
}

.document-blocked-title {
  font-weight: 700;
  color: #212529;
  margin: 0 0 6px 0;
}

.document-blocked-list {
  margin: 0 0 8px 0;
  padding-left: 18px;
  color: #495057;
}

.document-signed {
  color: #2b8a3e;
}

.document-unsigned {
  color: #868e96;
}
</style>
